// config/motDePasse.js
// Longueur minimale d'un NOUVEAU mot de passe (inscription, changement).
// À garder identique à backend/utils/politiqueComptes.js (LONGUEUR_MIN_MOT_DE_PASSE).
// Les anciens mots de passe de 6-7 caractères restent valables à la connexion.
export const LONGUEUR_MIN_MOT_DE_PASSE = 8;
